import { FC, ReactNode, useState } from 'react';
import { Button, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { LinkType } from './LinksFormInput';
import { ManageLinkModal } from './ManageLinkModal';

type Props = Readonly<{
	onChange: (link: LinkType) => void;
	size: 'medium' | 'small';
	hideAdd?: boolean;
}>;

const AddLinkButton: FC<Props> = ({ onChange, size, hideAdd }) => {
	const [manageLinkModal, setManageLinkModal] = useState<ReactNode>(null);

	return (
		<Stack direction={'row'} alignItems={'flex-start'} sx={{ width: '100%' }} gap={1.5}>
			<Button
				onClick={() => setManageLinkModal(<ManageLinkModal onChange={onChange} close={() => setManageLinkModal(null)} />)}
				startIcon={<Add />}
				variant={'text'}
				color={'secondary'}
				sx={{
					position: 'relative',
					left: -6,
					width: '100%',
					height: 28,
					justifyContent: 'start',
					textTransform: 'none',
					opacity: !hideAdd ? 1 : 0,
				}}
			>
				<FormattedMessage id={'common.link.placeholder'} />
			</Button>
			{manageLinkModal}
		</Stack>
	);
};

export { AddLinkButton };
